<div *ngIf="isLoading">Loading Person List...</div>

<select *ngIf="!isLoading" [compareWith]="byId" class="form-control" name="case" [(ngModel)]="model.person"
        [required]="required">
  <option [ngValue]="null" *ngIf="!singleOnly">Joint</option>
  <option *ngFor="let singlePerson of people" [ngValue]="singlePerson">{{ singlePerson.firstName }} {{
    singlePerson.lastName }}
  </option>
</select>
